import { toggleFeaturesActiveStatus } from './toggleFeaturesActiveStatus';
import { TThunkAction } from '../../types/redux';
import { updateFeatureProperties } from '../features';
import { markAsViewed } from '../viewed/markAsViewed';

export function selectNewbuildingFeatures(): TThunkAction {
  return (dispatch, getState) => {
    const {
      mapBounds: { precision },
      activeFeature,
      activeNewbuildingPolygon: { geohashIds, prevActiveGeoHashIds, newbuildingId },
      features,
    } = getState();

    if (activeFeature?.id) {
      dispatch(
        updateFeatureProperties({
          featureId: activeFeature.id,
          precision,
          properties: { isActive: false },
        }),
      );
    }

    // Сбрасываем isActive для предыдущих фич полигона
    dispatch(toggleFeaturesActiveStatus({ geohashIds: prevActiveGeoHashIds, isActive: false }));

    // Сбрасываем isActive для всех главных пинов ЖК, кроме текущего
    if (features[precision]) {
      const otherMainPins = Object.values(features[precision].features).filter(
        feature => feature.properties.isNewbuildingMainPin && feature.properties.newbuilding?.id !== newbuildingId,
      );

      otherMainPins.forEach(mainPinFeature => {
        dispatch(
          updateFeatureProperties({
            featureId: mainPinFeature.id,
            precision,
            properties: { isActive: false },
          }),
        );
      });
    }

    // Устанавливаем isActive для текущих фич полигона
    dispatch(toggleFeaturesActiveStatus({ geohashIds, isActive: true }));

    // Находим и обновляем главный пин ЖК
    if (newbuildingId && features[precision]) {
      const mainPinFeature = Object.values(features[precision].features).find(
        feature => feature.properties.isNewbuildingMainPin && feature.properties.newbuilding?.id === newbuildingId,
      );

      if (mainPinFeature) {
        dispatch(
          updateFeatureProperties({
            featureId: mainPinFeature.id,
            precision,
            properties: { isActive: true },
          }),
        );

        // Отмечаем главный пин как просмотренный
        dispatch(markAsViewed({ feature: mainPinFeature, precision, isDetailed: false }));
      }
    }
  };
}
